import { z } from 'zod';
import { positiveDecimal, rate } from './primitives.js';

/** Proposition modifiée par l'utilisateur avant validation : mêmes positions que la proposition de départ. */
const addLines = z.object({
  kind: z.literal('ADD_LINES'),
  newProjectName: z.string().trim().min(2).max(200).nullable().optional(),
  lines: z
    .array(
      z.object({
        chapterCode: z.string().min(1).max(30),
        designation: z.string().trim().min(1).max(500),
        unit: z.string().trim().min(1).max(20),
        quantity: positiveDecimal.nullable().optional(),
        basis: z.string().max(500).optional(),
      }),
    )
    .min(1)
    .max(200),
});

const applyCalculator = z.object({
  kind: z.literal('APPLY_CALCULATOR'),
  newProjectName: z.string().trim().min(2).max(200).nullable().optional(),
  values: z.array(z.object({ key: z.string().max(30), value: positiveDecimal, unit: z.string().max(20).optional() })).max(60),
  concrete: z.string().trim().max(30).optional(),
  masonry: z.string().trim().max(30).optional(),
});

const setAnalysis = z.object({
  kind: z.literal('SET_ANALYSIS'),
  yieldPerPeriod: positiveDecimal.nullable().optional(),
  components: z
    .array(
      z.object({
        kind: z.enum(['MATERIAL', 'LABOR', 'EQUIPMENT', 'MACHINE', 'TRANSPORT', 'OTHER']),
        designation: z.string().trim().min(1).max(200),
        unit: z.string().trim().min(1).max(20),
        quantity: positiveDecimal,
        unitPrice: positiveDecimal,
        lossRate: rate.nullable().optional(),
        atYield: z.boolean().optional(),
      }),
    )
    .min(1)
    .max(50),
});

export const aiAcceptSchema = z.object({ proposals: z.array(z.discriminatedUnion('kind', [addLines, applyCalculator, setAnalysis])).max(10).optional() });
